function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default (function (theme) {
  return {
    getCSS: function getCSS(_ref) {
      var targetElement = _ref.targetElement,
          stepsCount = _ref.stepsCount,
          isMinor = _ref.isMinor,
          isCurrent = _ref.isCurrent,
          isPrevious = _ref.isPrevious;

      switch (targetElement) {
        case "container":
          {
            return {
              display: "flex"
            };
          }

        case "item":
          {
            return {
              paddingTop: theme.space[4],
              paddingBottom: theme.space[4],
              width: "".concat(100 / stepsCount, "%")
            };
          }

        case "labelContainer":
          {
            return {
              display: "flex",
              height: "20px"
            };
          }

        case "label":
          {
            return {
              position: "relative",
              left: "50%",
              transform: "translateX(-50%)",
              whiteSpace: "nowrap",
              colorCurrent: "primary.blue.t100",
              colorNonCurrent: "black"
            };
          }

        case "itemContent":
          {
            return {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "40px",
              marginTop: theme.space[2],
              position: "relative"
            };
          }

        case "progressLeft":
          {
            return {
              position: "absolute",
              left: 0,
              width: "50%",
              height: "8px",
              top: "calc(50% - 4px)",
              backgroundColor: isPrevious || isCurrent ? theme.colors.primary.blue.t100 : theme.colors.white
            };
          }

        case "progressRight":
          {
            return {
              position: "absolute",
              left: "50%",
              width: "50%",
              height: "8px",
              top: "calc(50% - 4px)",
              backgroundColor: isPrevious ? theme.colors.primary.blue.t100 : theme.colors.white
            };
          }

        case "circle":
          {
            return _objectSpread(_objectSpread(_objectSpread({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: theme.radii[3],
              backgroundColor: theme.colors.white,
              color: theme.colors.black,
              boxSizing: "border-box",
              flexShrink: 0,
              zIndex: 1
            }, isMinor && {
              width: "20px",
              height: "20px"
            }), isCurrent && {
              border: "".concat(theme.borderWidths[1], " solid ").concat(theme.colors.primary.blue.t100)
            }), isPrevious && {
              backgroundColor: theme.colors.primary.blue.t100
            });
          }

        default:
          {
            return null;
          }
      }
    }
  };
});